// These redirect rules are based from sthp (header.js#changeUrlBeforeLogin)
// in the future we might need to have this kind of
// special logic in the client using the component
export const getRedirectUrl = (country, language) => {
  const currentUrl = location.href;
  let redirectUrl;
  if (currentUrl.indexOf('login') !== -1) {
    redirectUrl = `${location.origin}/${country}/${language}/account`;
    if (history.pushState) {
      history.pushState(
        {
          state: redirectUrl,
        },
        'ljudbocker',
        redirectUrl
      );
    }
  }

  // If no override or redirect url, return empty string
  return redirectUrl ? redirectUrl : '';
};
